import gql from 'graphql-tag'

export const UPDATE_PROFILE_PIC = gql`
mutation($id:uuid!,$profile:String) {
  update_Users(where: {id: {_eq: $id}}
    _set:{profile:$profile}){
    returning {
      id
     }
   }
}
`
export const UPDATE_FCM_TOKEN = gql`
mutation($token:uuid!,$fcmToken:String) {
  update_Session(where: {token: {_eq: $token}} _set:{pushNotificationId:$fcmToken}){
    returning {
      id
    }
  }
}
`
export const DELETE_SESSION_BY_TOKEN = gql`
mutation($token:uuid!){
  delete_Session(where: {token: {_eq: $token}}){
    returning {
      id
    }
  }
}
`
